import { Component, computed, inject, linkedSignal } from '@angular/core';
import { Router } from '@angular/router';
import { IconNames } from '@icon/assets';
import { UiButtonComponent, UIIconComponent, UiNumberComponent } from '@design-system';
import { MASKED_VALUE } from '../../../../models/masked-value.model';
import { getWalletBuyingPower } from '../../../../models/wallet.model';
import { GeneralSettingsService } from '../../../../services/general-settings.service';
import { WalletStore } from '../../data-access/wallet.store';
import { WalletMiniRow } from './wallet-mini.model';

/**
 * قدرت خرید under the desktop side menu — the footer's buying-power bar, always open,
 * for the layout that has no footer.
 *
 * Same figures as the bar: always the گواهی سپرده wallet, regardless of کیف پیش‌فرض.
 * The eye masks them for this card only; it opens on «عدم نمایش مانده», so a trader
 * who hides balances app-wide is not shown them here until they ask.
 */
@Component({
	selector: 'app-wallet-mini',
	imports: [UiButtonComponent, UIIconComponent, UiNumberComponent],
	templateUrl: './wallet-mini.component.html',
	host: {
		class: 'flex flex-col gap-2 rounded-2xl bg-gray-000 p-4'
	}
})
export class WalletMiniComponent {
	private readonly walletStore = inject(WalletStore);
	private readonly router = inject(Router);

	readonly amountsHidden = linkedSignal(inject(GeneralSettingsService).hideBalances);

	readonly visibilityIcon = computed<IconNames>(() => (this.amountsHidden() ? 'eye-off' : 'eye'));
	readonly visibilityLabel = computed(() => (this.amountsHidden() ? 'نمایش مبالغ' : 'پنهان کردن مبالغ'));

	readonly maskedValue = MASKED_VALUE;

	readonly rows = computed<WalletMiniRow[]>(() => {
		const wallet = this.walletStore.depositWallet();

		return [
			{ label: 'مانده گواهی سپرده', value: wallet.balance, emphasised: false, dataCy: 'wallet-mini-balance' },
			{ label: 'بلوکه شده', value: wallet.blocked, emphasised: true, dataCy: 'wallet-mini-blocked' },
			{
				label: 'قدرت خرید',
				value: getWalletBuyingPower(wallet),
				emphasised: false,
				dataCy: 'wallet-mini-buying-power'
			}
		];
	});

	toggleVisibility(): void {
		this.amountsHidden.update(hidden => !hidden);
	}

	onDepositRequested(): void {
		this.router.navigate(['/wallet/deposit']);
	}
}
